namespace TabAurous.Sales {
    export interface ApprovalOutItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        TaxCode?: string;
        DesignId?: number;
        DesignCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        DiscountPer?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        DeptName?: string;
        FancyCharges?: number;
        OtherCharges?: number;
        BOMDetails?: ApprovalOutBOMRow[];
        LaborDetails?: ApprovalOutLaborRow[];
        GroupId?: number;
        RoutingId?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MFAmount?: number;
        MF?: number;
        HasBom?: boolean;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        IsPosted?: boolean;
        HUID?: string;
        StampId?: number;
        ExportPieces?: number;
        CompanyCode?: string;
        Attribute?: string;
        ProductTypeCode?: string;
        ProductTypeName?: string;
        ItemType?: string;
        CategoryCode?: string;
        CategoryName?: string;
        SubCategoryCode?: string;
        SubCategoryName?: string;
        KaratCode?: string;
        KaratName?: string;
        MetalColorCode?: string;
        MetalColorName?: string;
        ProductSizeCode?: string;
        ProductSizeName?: string;
        StoneSizeCode?: string;
        StoneSizeName?: string;
        BrandCode?: string;
        BrandName?: string;
        CollectionCode?: string;
        CollectionName?: string;
        SuperTypeCode?: string;
        SuperTypeName?: string;
        ShapeCode?: string;
        ShapeName?: string;
        SieveCode?: string;
        SieveName?: string;
        GroupSieveCode?: string;
        GroupSieveName?: string;
        QualityCode?: string;
        QualityName?: string;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StampCode?: string;
        StampName?: string;
        MetalCode?: string;
        MetalName?: string;
        StoneCutCode?: string;
        StoneCutName?: string;
        StonePolishCode?: string;
        StonePolishName?: string;
        StoneSymmetryCode?: string;
        StoneSymmetryName?: string;
        StoneFluorescenceCode?: string;
        StoneFluorescenceName?: string;
        StoneCuletCode?: string;
        StoneCuletName?: string;
        StoneGirdleCode?: string;
        StoneGirdleName?: string;
        StoneRate?: number;
        OtherRate?: number;
    }

    export namespace ApprovalOutItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'Sales.ApprovalOutItems';
        export const deletePermission = 'Sales:Approval:Delete';
        export const insertPermission = 'Sales:Approval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Approval:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            TaxCode = "TaxCode",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalId = "MetalId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            DiscountPer = "DiscountPer",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeptName = "DeptName",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            GroupId = "GroupId",
            RoutingId = "RoutingId",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MFAmount = "MFAmount",
            MF = "MF",
            HasBom = "HasBom",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            IsPosted = "IsPosted",
            HUID = "HUID",
            StampId = "StampId",
            ExportPieces = "ExportPieces",
            CompanyCode = "CompanyCode",
            Attribute = "Attribute",
            ProductTypeCode = "ProductTypeCode",
            ProductTypeName = "ProductTypeName",
            ItemType = "ItemType",
            CategoryCode = "CategoryCode",
            CategoryName = "CategoryName",
            SubCategoryCode = "SubCategoryCode",
            SubCategoryName = "SubCategoryName",
            KaratCode = "KaratCode",
            KaratName = "KaratName",
            MetalColorCode = "MetalColorCode",
            MetalColorName = "MetalColorName",
            ProductSizeCode = "ProductSizeCode",
            ProductSizeName = "ProductSizeName",
            StoneSizeCode = "StoneSizeCode",
            StoneSizeName = "StoneSizeName",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            CollectionCode = "CollectionCode",
            CollectionName = "CollectionName",
            SuperTypeCode = "SuperTypeCode",
            SuperTypeName = "SuperTypeName",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            SieveCode = "SieveCode",
            SieveName = "SieveName",
            GroupSieveCode = "GroupSieveCode",
            GroupSieveName = "GroupSieveName",
            QualityCode = "QualityCode",
            QualityName = "QualityName",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StampCode = "StampCode",
            StampName = "StampName",
            MetalCode = "MetalCode",
            MetalName = "MetalName",
            StoneCutCode = "StoneCutCode",
            StoneCutName = "StoneCutName",
            StonePolishCode = "StonePolishCode",
            StonePolishName = "StonePolishName",
            StoneSymmetryCode = "StoneSymmetryCode",
            StoneSymmetryName = "StoneSymmetryName",
            StoneFluorescenceCode = "StoneFluorescenceCode",
            StoneFluorescenceName = "StoneFluorescenceName",
            StoneCuletCode = "StoneCuletCode",
            StoneCuletName = "StoneCuletName",
            StoneGirdleCode = "StoneGirdleCode",
            StoneGirdleName = "StoneGirdleName",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate"
        }
    }
}
